import angular from 'angular';
import reportsComponent from './reports.component';
import invoiceReport from './canned-reports/invoice-report/invoice-report';
import timesheetReport from './canned-reports/timesheet-report/timesheet-report';
import leaveReport from './canned-reports/leave-report/leave-report';
import overachieversReport from './canned-reports/overachievers-report/overachievers-report';
import chargecodeReport from './canned-reports/chargecode-report/chargecode-report';
import billableTimeReport from './canned-reports/billable-time-report/billable-time-report';
import seniorityReport from './canned-reports/seniority-report/seniority-report';
import projectExpirationReport from "./canned-reports/project-expiration-report/project-expiration-report";
import rateHoursSummaryReport from "./canned-reports/rate-hours-summary-report/rate-hours-summary-report";
import laborDistributionReport from './canned-reports/labor-distribution-report/labor-distribution-report';
import scheduleKSummaryReport from './canned-reports/schedule-k-summary-report/schedule-k-summary-report';

let reportsModule = angular.module('reports', [
  invoiceReport.name,
  timesheetReport.name,
  leaveReport.name,
  overachieversReport.name,
  chargecodeReport.name,
  billableTimeReport.name,
  seniorityReport.name,
  projectExpirationReport.name,
  rateHoursSummaryReport.name,
  laborDistributionReport.name,
  scheduleKSummaryReport.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('reports', reportsComponent);

export default reportsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/reports.js